function NfpSignature(ui) {
    this.ui = ui;
    this.modal = ui.modal;
    this.storage = ui.storage;
}

NfpSignature.prototype.clearStorage = function (who = dazethutil.me()) {
    this.storage.removeItem(who + "_signatureData");
}

NfpSignature.prototype.fromStorage = function (who) {
    const data = this.storage.getItem(who + "_signatureData")
    if (!data) {
        return false;
    }
    const result = JSON.parse(data);
    result.Who = who;
    return result;
}

NfpSignature.prototype.getSigningMessage = function ({Tokens}, who, nonce) {
    const msg = `Signing this message will allow you to access\ndownloads and submit updates to the NFPs on\nyour dashboard. It will not trigger a blockchain\ntransaction or cost any gas fees.\n\nYour NFP Collection: ${Tokens}\n\nWallet: ${who}\n\nNonce: ${nonce}`;
    const hash = dazethutil.hash([msg]);
    return {
        text: msg,
        hash: hash
    }
}

NfpSignature.prototype.toStorage = function (who, nonce, {Tokens}, msg, signature) {
    const data = {
        Signature: signature,
        SigHash: msg.hash,
        Tokens: Tokens,
        Nonce: nonce
    };
    this.storage.setItem(who + "_signatureData", JSON.stringify(data));
    return data;
}

NfpSignature.prototype.get = async function (address = {}, allowSigning) {
    return new Promise(async (resolve, reject) => {
        const tokens = await this.ui.upgrade.contracts[address].getMyTokenIDs(dazethutil.me());
        let input = {Tokens: tokens};

        let chain = this.ui.DefaultChainId();
        const nonce = Date.now();
        const me = dazethutil.me(chain.Chain);
        let data = this.fromStorage(me);
        let msg = null;
        if (data) {
            try {
                if (Math.floor((nonce - data.Nonce) / 1000) < 2592000) {

                    msg = this.getSigningMessage(data, me, data.Nonce);
                    if (data.SigHash && data.SigHash === msg.hash) {
                        return resolve(data);
                    }
                }

            } catch (e) {
                console.error(e);
                data = false;
            }
        }

        if (!allowSigning) {
            return reject(false);
        }

        msg = this.getSigningMessage(input, me, nonce);
        dazeth.web3.eth.personal.sign(msg.text, me).then(sig => {
            data = this.toStorage(me, nonce, input, msg, sig);
            return resolve(data);
        }, error => {
            this.clearStorage(me);
            if (error.code === -32602) {
                this.ui.ethUnlinked();
                reject(false);
                return;
            }
            this.modal.Error('Signing Canceled', 'You declined the signing request for the your collection, interaction with your collection has been cancelled.')
            reject(false);
        });
    });
}
